"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideBarAppButton = void 0;
const react_1 = __importDefault(require("react"));
const svgs_1 = require("../assets/svgs");
const material_1 = require("@mui/material");
const SideBarOpenStateStore_1 = __importDefault(require("../utils/zustand-stores/SideBarOpenStateStore"));
function SideBarAppButton({ app, onClick, sx, ...rest }) {
    const theme = (0, material_1.useTheme)();
    const { setOpen } = (0, SideBarOpenStateStore_1.default)();
    const defaultSX = {
        fontFamily: 'Effra',
        fontSize: '1.13131rem',
        fontWeight: 600,
        display: 'flex',
        alignItems: 'start',
        color: theme.palette.primary.contrastText,
        backgroundColor: '#FFFFFF0A',
        padding: '1rem',
        borderRadius: '0.75rem',
        textTransform: 'none',
    };
    const mergedSX = { ...defaultSX, ...sx };
    return (react_1.default.createElement(material_1.Button, { onClick: e => {
            setOpen(false);
            if (onClick) {
                onClick(e);
            }
        }, sx: mergedSX, ...rest },
        react_1.default.createElement("div", { className: "flex flex-row gap-[0.5rem] items-center justify-center" },
            getIcon(app),
            getBrand(app))));
}
exports.SideBarAppButton = SideBarAppButton;
function getIcon(app) {
    switch (app) {
        case 'PopStudy':
            return react_1.default.createElement(svgs_1.PopStudyLogo, { className: "w-auto h-[1rem]" });
        case 'PopQuiz':
            return react_1.default.createElement(svgs_1.PopQuizLogo, { className: "w-auto h-[1rem]" });
        case 'PopTeams':
            return react_1.default.createElement(svgs_1.PopTeamsLogo, { className: "w-auto h-[1rem]" });
        case 'PopStack':
            return react_1.default.createElement(svgs_1.PopStackLogo, { className: "w-auto h-[1rem]" });
    }
}
function getBrand(app) {
    switch (app) {
        case 'PopStudy':
            return react_1.default.createElement(svgs_1.PopStudyBrandWhite, { className: "h-[1rem] w-auto" });
        case 'PopQuiz':
            return react_1.default.createElement(svgs_1.PopQuizBrandWhite, { className: "h-[1rem] w-auto" });
        case 'PopTeams':
            return react_1.default.createElement(svgs_1.PopTeamsBrandWhite, { className: "h-[1rem] w-auto" });
        case 'PopStack':
            return react_1.default.createElement(svgs_1.PopStackBrandWhite, { className: "h-[1rem] w-auto" });
    }
}
